import CountUp from './CountUp';

export default CountUp;
